export const markValuesEnum = {
    excellent: 5,
    good: 4,
    satisfactory: 3,
    unsatisfactory: 2,
    notEvaluable: 1,
    absence: 0
};